import React, { useContext } from 'react';
import ExtraPaymentType from './components/ExtraPaymentType';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from 'modules/CustomersAndRestaurants/Restaurants/RestaurantFullInfo/restaurantFullInfoState/restaurantFullInfoContext';
import { IExtraPaymentType } from 'modules/CustomersAndRestaurants/Restaurants/EditRestaurant/editRestaurantState/editRestaurantContext';
import { CardBrands } from 'types/customers';

const ExtraPaymentTypes: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	const data = restaurantForFullInfo?.extraPaymentTypes ?? {};
	const extraPaymentTypes: IExtraPaymentType[] = Object.keys(data).map((key, idx) => {
		return {
			id: String(idx),
			brand: CardBrands[key as keyof typeof CardBrands],
			paymentTypeId: data[key] as string,
		};
	});

	return (
		<div>
			{extraPaymentTypes.map((el) => (
				<ExtraPaymentType key={el.id} extraPaymentType={el} />
			))}
		</div>
	);
};

export default React.memo(ExtraPaymentTypes);
